const sidebarName_en = {
  exhibitorAdmin: "Exhibitor Admin.",
  visitorAdmin: "Visitor Admin.",
  forumAdmin: "Fourm Admin.",
  guestSeats: "guests seats",
  forumTable: "Forum",
  guestList: "Attendee List",
  experience: "Test Meeting",
  experiencegz: "Test Meeting"
}

const sidebarName_ch = {
  exhibitorAdmin: "招聘管理",
  visitorAdmin: "观展管理",
  orderManage:'订单管理',
  forumAdmin: "论坛管理",
  guestSeats: "嘉宾席位",
  forumTable: "论坛列表",
  guestList: "应聘者名录",
  experience: "展商体验",
  interviewRecords:'面试记录',
  onlineResume:'在线简历',
  experiencegz: "体验测试",
  ticketsManage:'门票管理'
}
export {
  sidebarName_ch,
  sidebarName_en
}
